import dayjs from 'dayjs';
import { CompteMobileLight, ICompteMobileLight } from '../dto/compte-mobile.light.model';

export class HistoriqueRefus {
  constructor(
    public readonly agent: ICompteMobileLight,
    public readonly instant: Date,
    public readonly raison?: string,
    public readonly motifId?: string
  ) {}
  public static hydrate(obj: HistoriqueRefus): HistoriqueRefus {
    return new HistoriqueRefus(CompteMobileLight.hydrate(obj.agent), dayjs(obj.instant).toDate(), obj.raison, obj.motifId);
  }
}
